(function ($) {
    $(document).ready(function () {

        var context,
            module = {
            /**
             * @type {String} The class name of the user approval toggle container.
             */
            toggleClass: 'user-approval-toggle',

            /**
             * Initialise.
             *
             * @param {jQuery} context The context for the functionality.
             */
            init: function ($context) {
                this.$context = $context;

                this.openClass = this.toggleClass + '--open';
                this.pendingActionClass = this.toggleClass + '--pending';
                this.approvedStateClass = this.toggleClass + '--approval-state-approved';
                this.disapprovedStateClass = this.toggleClass + '--approval-state-disapproved';

                this.toggleContainers = $context.find('.' + this.toggleClass);
            },

            /**
             * Get the parent toggle container for an element.
             *
             * @param {jQuery} $element The element.
             *
             * @return {jQuery} The toggle container.
             */
            getParentToggleContainer: function ($element) {
                return $element.closest('.' + this.toggleClass);
            },

            /**
             * Determine if a container is open.
             *
             * @param {jQuery} $toggleContainer The toggle container.
             *
             * @return {Boolean} True if the container is open.
             */
            isOpen: function ($toggleContainer) {
                return $toggleContainer.hasClass(this.openClass);
            },

            /**
             * Close the menu for the container.
             *
             * @param {jQuery} $toggleContainer The toggle container.
             */
            closeMenuForContainer: function ($toggleContainer) {
                $toggleContainer.removeClass(this.openClass);
            },

            /**
             * Open the menu for the container.
             *
             * @param {jQuery} $toggleContainer The toggle container.
             */
            openMenuForContainer: function ($toggleContainer) {
                $toggleContainer.addClass(this.openClass);

                this.closeAllOtherMenus($toggleContainer);
            },

            /**
             * Close all menus except the one given.
             *
             * @param {jQuery} $toggleContainer The toggle container to remain open.
             */
            closeAllOtherMenus: function ($toggleContainer) {
                var self = this,
                    toggleContainerDom = $toggleContainer.get(0);

                this.toggleContainers.each(function (i, item) {
                    if (item != toggleContainerDom) {
                        self.closeMenuForContainer($(item));
                    }
                });
            },

            /**
             * Close all menus.
             */
            closeAllMenus: function () {
                this.toggleContainers.removeClass(this.openClass);
            },

            /**
             * Determine if a click was made on or inside an open toggle container.
             *
             * @param {Event} evt The click event.
             *
             * @return {Boolean} True if the click was on or inside a toggle container.
             */
            isClickInsideOpenToggle: function (evt) {
                var $clicked = $(evt.target);

                return $clicked.hasClass(this.openClass) || $clicked.closest('.' + this.openClass).length > 0;
            },

            /**
             * Determine if the user in the toggle container is approved.
             *
             * @param {jQuery} $toggleContainer The toggle container.
             *
             * @return {Boolean} True if the user is approved.
             */
            isUserApproved: function ($toggleContainer) {
                return $toggleContainer.hasClass(this.approvedStateClass);
            },

            /**
             * Determine if the user in the toggle container is disapproved.
             *
             * @param {jQuery} $toggleContainer The toggle container.
             *
             * @return {Boolean} True if the user is disapproved.
             */
            isUserDisapproved: function ($toggleContainer) {
                return $toggleContainer.hasClass(this.disapprovedStateClass);
            },

            /**
             * Get all toggle containers in context for the specified user.
             *
             * @param {number} userId The ID of the user.
             *
             * @return {jQuery} The toggleContainer elements relevant to the given user.
             */
            getToggleContainersForUser: function (userId) {
                return this.toggleContainers.filter('[data-user-id=' + userId + ']');
            },

            /**
             * Set the current approval state.
             *
             * @param {number} userId The ID of the user.
             * @param {Boolean} isApproved If true, the user is marked approved, if false they are shown as disapproved.
             */
            setCurrentApprovalState: function (userId, isApproved) {
                // Note: One author may have multiple dropdowns on the page - update all of them to stay in sync.
                var relevantToggleContainers = this.getToggleContainersForUser(userId);

                if (isApproved) {
                    relevantToggleContainers.addClass(this.approvedStateClass)
                        .removeClass(this.disapprovedStateClass);
                } else {
                    relevantToggleContainers.addClass(this.disapprovedStateClass)
                        .removeClass(this.approvedStateClass);
                }
            },

            /**
             * Callback for a successful approval/disapproval request.
             *
             * @param {Object} data The JSON returned by the request.
             * @param {number} userId The ID of the user.
             * @param {jQuery} $parentContainer The parent container.
             * @param {bool} wasApproval If true, this was an approval request, otherwise it was a disapproval request.
             */
            onAjaxSuccess: function (data, userId, $parentContainer, wasApproval) {
                $parentContainer.removeClass(this.pendingActionClass);

                if (data.success) {
                    this.setCurrentApprovalState(userId, wasApproval);
                }
            },

            /**
             * Callback for an unsuccessful approval/disapproval request.
             *
             * @param {jQuery} $parentContainer The parent container.
             */
            onAjaxError: function ($parentContainer) {
                $parentContainer.removeClass(this.pendingActionClass);

                alert('Error: Please try again later.');
            },

            /**
             * Handle the click on the menu toggle (the username).
             *
             * @param {Event} evt The click event.
             */
            handleToggleButtonClick: function (evt) {
                var $clickedButton = $(evt.target),
                    $parentContainer = this.getParentToggleContainer($clickedButton);

                if (this.isOpen($parentContainer)) {
                    this.closeMenuForContainer($parentContainer);
                } else {
                    this.openMenuForContainer($parentContainer);
                }
            },

            /**
             * Handle a click on the body element.
             *
             * @param {Event} evt The click event.
             */
            handleBodyClick: function (evt) {
                if (!this.isClickInsideOpenToggle(evt)) {
                    this.closeAllMenus();
                }
            },

            /**
             * Handle a click on the approve button.
             *
             * @param {Event} evt The click event.
             *
             * @return {Boolean} False.
             */
            handleApproveButtonClick: function (evt) {
                var self = this,
                    $clickedLink = $(evt.target),
                    $parentContainer = this.getParentToggleContainer($clickedLink),
                    userId;

                if (!this.isUserApproved($parentContainer)) {
                    userId = $parentContainer.data('user-id');

                    $parentContainer.addClass(this.pendingActionClass);

                    $.ajax({
                        url: '/designspark/admin/moderation/users/' + userId + '/approve',
                        method: 'POST',
                        success: function (data) {
                            self.onAjaxSuccess(data, userId, $parentContainer, true);
                        },
                        error: function () {
                            self.onAjaxError($parentContainer);
                        }
                    });
                }

                this.closeMenuForContainer($parentContainer);

                return false;
            },

            /**
             * Handle a click on the disapprove button.
             *
             * @param {Event} evt The click event.
             *
             * @return {Boolean} False.
             */
            handleDisapproveButtonClick: function (evt) {
                var self = this,
                    $clickedLink = $(evt.target),
                    $parentContainer = this.getParentToggleContainer($clickedLink),
                    userId;

                if (!this.isUserDisapproved($parentContainer)) {
                    userId = $parentContainer.data('user-id');

                    $parentContainer.addClass(this.pendingActionClass);

                    $.ajax({
                        url: '/designspark/admin/moderation/users/' + userId + '/disapprove',
                        method: 'POST',
                        success: function (data) {
                            self.onAjaxSuccess(data, userId, $parentContainer, false);
                        },
                        error: function () {
                            self.onAjaxError($parentContainer);
                        }
                    });
                }

                this.closeMenuForContainer($parentContainer);

                return false;
            }
        };

        context = $('body');

        module.init(context);

        // Open or close the menu when a toggle button is clicked.
        context.find('.user-approval-toggle__username').click(module.handleToggleButtonClick.bind(module));

        // Close any other open toggles when a click is detected outside of the open toggle.
        context.click(module.handleBodyClick.bind(module));

        // Handle clicks on the approve link.
        context.find('.user-approval-toggle__menu-item--action-approve a').click(module.handleApproveButtonClick.bind(module));

        // Handle clicks on the disapprove link.
        context.find('.user-approval-toggle__menu-item--action-disapprove a').click(module.handleDisapproveButtonClick.bind(module));
    });
})(window.jQuery);



// WEBPACK FOOTER //
// ./src/js/legacy/js/user-approval-toggle.js